import { render } from "./Offset.vue?vue&type=template&id=81b88f84"
import script from "./Offset.vue?vue&type=script&lang=js"
export * from "./Offset.vue?vue&type=script&lang=js"

import "./Offset.vue?vue&type=style&index=0&id=81b88f84&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__